import { render, staticRenderFns } from "./AppointmentListItem.vue?vue&type=template&id=f5dc2a9a&scoped=true&"
import script from "./AppointmentListItem.vue?vue&type=script&lang=ts&"
export * from "./AppointmentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentListItem.vue?vue&type=style&index=0&id=f5dc2a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dc2a9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VListItem,VListItemAction,VListItemContent,VListItemIcon,VListItemTitle,VSheet,VSpacer})
